import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./layout/AdminLayout";
import Dashboard from "./pages/Dashboard";
import Orders from "./pages/Orders";
import Products from "./pages/Products";
import Users from "./pages/Users";
import Notifications from "./pages/Notifications";
import AdminProducts from "./pages/AdminProducts";
import Settings from "./pages/Settings";
import Reports from "./pages/Reports";

import AdminForgotPassword from "./pages/AdminForgotPassword";
import AdminResetPassword from "./pages/AdminResetPassword";

// ✅ ALLOWED ROLES
const ALLOWED_ROLES = ["admin", "superadmin", "sales"];

// ✅ PROTECTED ROUTE
const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem("access");
  const role = localStorage.getItem("user_role");

  if (!token || !ALLOWED_ROLES.includes(role)) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default function AdminRoutes() {
  return (
    <Routes>
      {/* 🔓 Public admin auth routes */}
      <Route path="forgot-password" element={<AdminForgotPassword />} />
      <Route path="reset-password" element={<AdminResetPassword />} />

      {/* 🔐 Protected admin routes */}
      <Route
        element={
          <ProtectedAdminRoute>
            <AdminLayout />
          </ProtectedAdminRoute>
        }
      >
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="orders" element={<Orders />} />
        <Route path="products" element={<Products />} />
        <Route path="users" element={<Users />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="AdminProducts" element={<AdminProducts />} />
        <Route path="settings" element={<Settings />} />
        <Route path="reports" element={<Reports />} />

        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Route>
    </Routes>
  );
}